import { defineSlotRecipe } from '@chakra-ui/react';

/** Bottom sheet paint. Snap points and z-index stay in the component. */
export const sheetSlotRecipe = defineSlotRecipe({
  slots: ['container', 'handle'],
  base: {
    container: {
      bg: 'bg',
      color: 'text',
      borderTopWidth: 'hairline',
      borderColor: 'border',
      borderTopRadius: '2xl',
    },
    handle: {
      bg: 'border',
      borderRadius: 'full',
      w: '46px',
      h: '3px',
      opacity: 0.6,
    },
  },
  variants: {
    elevated: {
      true: {
        container: { bg: 'bgElevated' },
      },
    },
  },
});
